import React from 'react';
import styled from 'styled-components';
import { TextHeadingTwo, Text, Flex, Box } from '@cko/primitives';
const Content = styled.div `
  text-align: center;
`;
export const StyledIcon = styled(Flex) `
  justify-content: center;
  & svg {
    height: 208px;
    width: 208px;
  }
`;
export const FallbackBackground = ({ header, icon, text, children }) => {
    return (React.createElement(Flex, { flex: "1 0", justifyContent: "center", alignItems: "center", flexDirection: "column", width: "100%", height: "100%", "data-testid": "fallback-background" },
        React.createElement(Content, null,
            icon && (React.createElement(StyledIcon, { "data-testid": "fallback-background-icon", marginBottom: "var(--layout-saxophone)" }, icon)),
            React.createElement(TextHeadingTwo, null, header),
            text && (React.createElement(Text, { color: "var(--base-text-secondary)", font: "var(--body-xs)", marginTop: "var(--layout-soybean)" }, text)),
            React.createElement(Box, { marginTop: "var(--layout-soybean)" }, children))));
};
